const Licence_DOWNLOAD = [
    {
        sectionID: 'licenceDownload',
        sectionName: '',
        fieldList: [
            {
                id: 'licence-download',
                label: '',
                type: 'tableDownload',
                rule: { disabled: true },
                defaultValue: [{ id: 'licenceFile', data: ['Licence', 'PDF', 'Download'] }],
                subFields: [
                    {
                        id: 'file-name',
                        header: 'File Name',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'category',
                        header: 'Category',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'created-date',
                        header: 'Created Date',
                        type: 'dateTime'
                    },
                    {
                        id: 'download',
                        header: 'Download',
                        type: 'dateTime',
                        rule: { disabled: true }
                    }
                ],
                span: 12
            }
        ]
    }
];

export default Licence_DOWNLOAD;
